module.exports = __webpack_public_path__ + "img/dmm.020f7183.jpg";